import React, { Component, createRef } from 'react';
import './styles.css';
import { upload } from '../../api/schedule';
import PropTypes from 'prop-types';

export default class ScheduleUpload extends Component {
  constructor() {
    super();
    this.state = {
      isUploading: false,
      showModal: false, // Controls whether the modal is visible
    };
    this.fileInputRef = createRef();

    this.filesOnChange = this.filesOnChange.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleConfirm() {
    this.setState({ showModal: false }, () => {
      // Once modal is closed, open the file dialog
      if (this.fileInputRef.current) {
        this.fileInputRef.current.click();
      }
    });
  }

  handleCancel() {
    this.setState({ showModal: false });
  }

  filesOnChange(event) {
    this.setState({ isUploading: true });

    const files = event.target.files;
    const form = new FormData();
    for (let file of files) {
      form.append('file', file);
    }

    // Reset file input
    event.target.value = '';

    upload(form)
      .then((response) => {
        this.setState({ isUploading: false });
        if (response.ok) {
          this.props.onSuccess();
        } else {
          this.props.onError();
        }
      })
      .catch(() => {
        this.setState({ isUploading: false });
        this.props.onError();
      });
  }

  render() {
    const { isUploading, showModal } = this.state;
    const text = isUploading ? 'Uploading...' : 'Upload file';

    return (
      <div className="fileinput fileinput-new" data-provides="fileinput">
        {/* Button to trigger modal */}
        <button
          type="button"
          className="dropdown-item"
          onClick={this.handleOpenModal}
          disabled={isUploading}
        >
          {text}
        </button>

        {/* Hidden file input */}
        <input
          ref={this.fileInputRef}
          type="file"
          style={{ display: 'none' }}
          disabled={isUploading}
          onChange={this.filesOnChange}
        />

        {/* Modal (only shown if showModal === true) */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h4>Important</h4>
              <p>
                This feature is for bulk creation and assigning/unassigning
                of delivery pools. <strong>Reassigning</strong> from one pool
                to another is <strong>not</strong> supported.
              </p>
              <div className="modal-actions">
                <button type="button" className="btn-sm btn-primary" onClick={this.handleConfirm}>OK, Proceed</button>
                <button type="button" className="btn-sm btn-secondary" onClick={this.handleCancel}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

ScheduleUpload.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/scheduleUpload/index.js